import { v4 as uuidv4 } from "uuid";
let hometypeArr = [
  {
    name: "Rooms",
    path: "Airbnb/images/hometype-icons/rooms.jpg",
    id: uuidv4(),
  },
  {
    name: "Amazing pools",
    path: "Airbnb/images/hometype-icons/amazing-pools.jpg",
    id: uuidv4(),
  },
  {
    name: "Amazing views",
    path: "Airbnb/images/hometype-icons/amazing-views.jpg",
    id: uuidv4(),
  },
  {
    name: "Lakefront",
    path: "Airbnb/images/hometype-icons/lakefront.jpg",
    id: uuidv4(),
  },
  {
      name: "Windmills",
      path: "Airbnb/images/hometype-icons/windmills.jpg",
      id: uuidv4(),
    },
    {
      name: "Mansions",
      path: "Airbnb/images/hometype-icons/mansions.jpg",
      id: uuidv4(),
    },
    {
      name: "Tiny homes",
      path: "Airbnb/images/hometype-icons/tiny-homes.jpg",
      id: uuidv4(),
    },
    {
      name: "Creative spaces",
      path: "Airbnb/images/hometype-icons/creative-spaces.jpg",
      id: uuidv4(),
    },
  {
    name: "Castles",
    path: "Airbnb/images/hometype-icons/castles.jpg",
    id: uuidv4(),
  },
  {
    name: "Riads",
    path: "Airbnb/images/hometype-icons/riads.jpg",
    id: uuidv4(),
  },
  {
    name: "Grand pianos",
    path: "Airbnb/images/hometype-icons/grand-pianos.jpg",
    id: uuidv4(),
  },
  {
    name: "Design",
    path: "Airbnb/images/hometype-icons/design.jpg",
    id: uuidv4(),
  },
  {
    name: "OMG!",
    path: "Airbnb/images/hometype-icons/OMG!.jpg",
    id: uuidv4(),
  },{
    name: "trending",
    path: "Airbnb/images/hometype-icons/trending.jpg",
    id: uuidv4(),
  },{
    name: "Windmills",
    path: "Airbnb/images/hometype-icons/windmills.jpg",
    id: uuidv4(),
  },{
    name: "Lake",
    path: "Airbnb/images/hometype-icons/lake.jpg",
    id: uuidv4(),
  },{
    name: "Trulli",
    path: "Airbnb/images/hometype-icons/trulli.jpg",
    id: uuidv4(),
  },{
    name: "Luxe",
    path: "Airbnb/images/hometype-icons/luxe.jpg",
    id: uuidv4(),
  },{
    name: "Shepherd's huts",
    path: "Airbnb/images/hometype-icons/shepherd's-huts.jpg",
    id: uuidv4(),
  },{
    name: "Boats",
    path: "Airbnb/images/hometype-icons/boat.jpg",
    id: uuidv4(),
  },{
    name: "Casas particulares",
    path: "Airbnb/images/hometype-icons/casas-particulares.jpg",
    id: uuidv4(),
  },{
    name: "Farms",
    path: "Airbnb/images/hometype-icons/farms.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Skiing",
    path: "Airbnb/images/hometype-icons/skiing.jpg",
    id: uuidv4(),
  },
  ,{
    name: "National parks",
    path: "Airbnb/images/hometype-icons/national-parks.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Houseboats",
    path: "Airbnb/images/hometype-icons/houseboats.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Caves",
    path: "Airbnb/images/hometype-icons/caves.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Treehouses",
    path: "Airbnb/images/hometype-icons/treehouses.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Arctic",
    path: "Airbnb/images/hometype-icons/arctic.jpg",
    id: uuidv4(),
  },
  ,{
    name: "Golfing",
    path: "Airbnb/images/hometype-icons/golfing.jpg",
    id: uuidv4(),
  },
  
];

export default hometypeArr;
